import { DynamicStandaloneFooter, DynamicStandaloneFooterProps } from '@/components/Footer';
import { DynamicStandaloneMain, DynamicStandaloneMainProps } from '@/components/Main';
import { DynamicStandaloneNavigation, DynamicStandaloneNavigationProps } from '@/components/Navigation';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ReactNode } from 'react';

export interface StandaloneBaseProps extends StandaloneComponentProps {
  content?: ReactNode;
  options?: {
    $navigation?: DynamicStandaloneNavigationProps;
    $main?: DynamicStandaloneMainProps;
    $footer?: DynamicStandaloneFooterProps;
  };
}

export const StandaloneBase: StandaloneComponent<StandaloneBaseProps> = ({ content, options }) => {
  const { $navigation, $main, $footer } = { ...options };

  return (
    <>
      <DynamicStandaloneNavigation {...$navigation} />
      <DynamicStandaloneMain content={content} {...$main} />
      <DynamicStandaloneFooter {...$footer} />
    </>
  );
};

export default StandaloneBase;
